import React, { useState, useEffect } from "react";
import Global from '../../APIConfig';
import  axios from "axios";
import AuthUser from "../../AuthUser";
import { useNavigate } from "react-router-dom";
import { Bar,Line } from 'react-chartjs-2'
import { Chart, registerables } from 'chart.js'
import ListLoader from "../Loaders/ListLoader";
Chart.register(...registerables)

function TopHubChart(){
    let navigate = useNavigate();
    const{headers1,logout}=AuthUser();
    const [Loading, setLoading] = useState(true);
    const [label, setLabel] = useState('');
    const [typeVal, setTypeVal] = useState('');
    useEffect(()=>{
        Get30DaysShipmentDetail();
    },[]);
    
    const Get30DaysShipmentDetail=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Get30DaysHubBooking',
            headers:headers1,
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data;
                setLabel(data.label);
                setTypeVal(data.TypeVal);
                
            }
            else
            {
                setLabel(0);
                setTypeVal(0);
                
            }
            setLoading(false);
          })
          .catch(function (error) {
            if(error.response.status==401){
                logout();
                navigate('/');
                window.location.reload();
            }
            setLoading(false);
            // console.log(error);
          });
    }

    const state = {
        labels: label,
        datasets: [
          {
            label: 'Hubs',
            backgroundColor: [
                '#3f37c9',
                '#FBA918',
                '#2361ce',
                '#dc3545',
                '#fd7e14',
                '#6610f2'
              ],
            borderColor:[
                '#3f37c9',
                '#FBA918',
                '#2361ce',
                '#dc3545',
                '#fd7e14',
                '#6610f2'
              ],
            borderWidth: 2,
            data:typeVal,
          },
        ],
      }
    return (
      <>
            {Loading==true ? <ListLoader/> :
            <>
          <Bar
            data={state}
            options={{
              title: {
                display: true,
                text: 'Hubs',
                fontSize: 20,
              },
              legend: {
                display: true,
                position: 'right',
              },
            }}
          />
          </>
          }
          </>
      )
}

export default TopHubChart;
  
